<template>
    <div>
        <div v-if="loading" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else>

            <template v-if="Object.keys(this.conteudos).length > 0">
                <el-tabs type="border-card" v-model="tabAtivo">

                    <el-tab-pane :name="stringToSlug(i)" v-for="(conteudo, i) in conteudos" :key="i" :label="i">                  

                        <div class="container-table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th style="width: 120px;">data</th>
                                        <th>Atividades desenvolvidas</th>
                                        <th>Qtd. Aulas</th>
                                        <th>Usuário</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(data, j) in conteudo">
                                        <tr v-for="(item, y) in data" :key="j+y">
                                            <td>{{ $moment(item.data).format('DD/MM/YYYY') }}</td>
                                            <td>{{ item.atividade_desenvolvida }}</td>
                                            <td>{{ item.horarios.length }}</td>
                                            <td>{{ item.user.name }}</td>                                    
                                        </tr>
                                    </template>                                
                                </tbody>
                            </table>
                        </div>

                    </el-tab-pane>

                </el-tabs>
            </template>
            <template v-else>

                <div class="u-text-center" style="padding: 100px 0;">
                    <i>Nenhuma atividade registrada</i>
                </div>

            </template>
            
            <div class="u-text-right u-mt-10">
                <el-button type="primary" @click="close">FECHAR</el-button>
            </div>
        </div>    
    </div>
</template>
<script>


export default {
    props: ['turma_id'],
    data: () => ({
        defineQtdAtividades: {},
        tabAtivo: null,
        conteudos: {},
        loading: true
    }),
    mounted () {

        this.getConteudo();        
    },
    methods: {
        getConteudo(){

            this.loading = false;
            
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/conteudo/getConteudoByTurma/${this.turma_id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});
                    this.$emit('close');

                }else{

                    this.conteudos = response.data;

                    if(Object.keys(this.conteudos).length > 0) {
                        this.tabAtivo = this.stringToSlug(Object.keys(this.conteudos)[0]);
                    }

                    this.loading = false;

                } 

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },     
        close(){
            this.$emit('close');
        },
        stringToSlug(str) {
            return str
                .toLowerCase() // Converte para minúsculas
                .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Remove acentos
                .replace(/[^a-z0-9 -]/g, "") // Remove caracteres especiais
                .replace(/\s+/g, "-") // Substitui espaços por "-"
                .replace(/-+/g, "-"); // Remove múltiplos "-"
        }
    },
    components:{  }
}
</script>
<style>
  
  
</style>